export const useSliderTransition = (
  initialIndex?: number,
  useGap: boolean = true
) => {
  const selectedIndex = ref<number>(initialIndex ?? 0)

  const selectedPreviousIndex = ref<number>(initialIndex ?? 0)

  const slider = ref<HTMLElement | null>(null)

  onMounted(() => {
    if (slider.value) {
      slider.value.style.left = '0px'
    }
  })

  const getShortcutElement = (index: number): HTMLElement | null => {
    const elements = document.querySelectorAll<HTMLElement>('.shortcut-element')
    return elements[index] || null
  }
  const updateSliderPosition = async (index: number) => {
    await nextTick() // wait after 'font-bold' or other styles has been applied to the selected tab, since it affects layout.
    if (!slider.value) return 0

    const targetButton = getShortcutElement(index)
    if (!targetButton) return

    slider.value.style.width = `${targetButton.offsetWidth}px`
    slider.value.style.transform = `translateX(${Math.abs(targetButton.offsetLeft)}px)`
  }

  const handleShortcutClick = (index: number): void => {
    selectedPreviousIndex.value = selectedIndex.value
    if (selectedIndex.value !== index) {
      selectedIndex.value = index
    }
  }

  const handleKeydown = (event: KeyboardEvent): void => {
    const elements = document.querySelectorAll('.shortcut-element')

    const activeElement = document.activeElement as HTMLElement
    if (
      !activeElement.classList.contains('shortcut-element') &&
      !activeElement.dataset.tabController
    )
      return

    if (event.key === 'ArrowRight') {
      event.preventDefault()
      selectedIndex.value = (selectedIndex.value + 1) % elements.length
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault()
      selectedIndex.value =
        selectedIndex.value > 0 ? selectedIndex.value - 1 : elements.length - 1
    }

    const newElement = getShortcutElement(selectedIndex.value)
    newElement?.focus()
    updateSliderPosition(selectedIndex.value)
  }

  const handleResize = () => updateSliderPosition(selectedIndex.value)

  onMounted(() => {
    updateSliderPosition(selectedIndex.value)
    window.addEventListener('resize', handleResize)
    window.addEventListener('keydown', handleKeydown)

    getShortcutElement(selectedIndex.value)?.focus()
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize)
    window.removeEventListener('keydown', handleKeydown)
  })

  watch(selectedIndex, (newIndex: number) => {
    updateSliderPosition(newIndex)
  })

  return {
    selectedIndex,
    slider,
    handleShortcutClick,
    updateSliderPosition,
  }
}
